// Client/src/pages/digi/NewMasterSheet/ComputedCell.jsx
//
// One computed column's cell: the label (a pill for insurance), and the (i) for the four
// columns that have detail. Loading and failure states are the sheet's, passed in.
import React, { useRef } from "react";
import {
  COMPUTED_COLUMNS, insuranceLabel, padThisMonthLabel, futureLeaseLabel, totalDepositLabel, addendumsLabel, incentivesLabel,
} from "./rowExtras";

const DETAIL_KEYS = new Set(["__x_insurance", "__x_addendums", "__x_incentives", "__x_futureLease"]);

const moneyStr = (n) => `$${Number(n ?? 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const ComputedCell = ({ columnKey, extras, state, isOpen, onToggle, unitNo }) => {
  const btnRef = useRef(null);
  if (state === "loading") return <span className="rx-cell--loading" role="status" aria-label="Loading" />;
  if (state === "error" || !extras) return <span className="rx-cell rx-pill--muted">—</span>;

  let content;
  let title = "";
  switch (columnKey) {
    case "__x_leaseKind": content = extras.leaseKind || "—"; break;
    case "__x_totalDeposit": {
      const d = extras.totalDeposit;
      content = totalDepositLabel(d);
      title = d?.total != null ? `Security ${moneyStr(d.security)} + Pet ${moneyStr(d.pet)} + PSF ${moneyStr(d.nonRefundable)}` : "";
      break;
    }
    case "__x_insurance": {
      const l = insuranceLabel(extras.insurance);
      content = <span className={`rx-pill rx-pill--${l.tone}`}>{l.text}</span>;
      break;
    }
    case "__x_addendums": content = addendumsLabel(extras.addendums); break;
    case "__x_incentives": content = incentivesLabel(extras.incentives); break;
    case "__x_padThisMonth": content = padThisMonthLabel(extras.padThisMonth); title = extras.padThisMonth?.note || ""; break;
    case "__x_futureLease": content = futureLeaseLabel(extras.futureLease); break;
    case "__x_aiSuggestion":
      content = extras.aiSuggestion ? extras.aiSuggestion.verdict : "—";
      title = extras.aiSuggestion ? `as of ${extras.aiSuggestion.as_of}` : "";
      break;
    default: content = "—";
  }

  const hasDetail = DETAIL_KEYS.has(columnKey) && !(columnKey === "__x_futureLease" && !extras.futureLease) && extras.insurance?.status !== "VACANT";
  return (
    <span className="rx-cell" title={title}>
      {content}
      {hasDetail && (
        <button
          ref={btnRef}
          type="button"
          className="rx-info"
          aria-label={`${COMPUTED_COLUMNS.find((c) => c.key === columnKey)?.label || "Details"} details, unit ${unitNo ?? ""}`}
          aria-haspopup="dialog"
          aria-expanded={isOpen}
          onClick={(e) => { e.stopPropagation(); onToggle(btnRef); }}
        >
          i
        </button>
      )}
    </span>
  );
};

export default ComputedCell;
